export default "__VITE_ASSET__g7p13Av8__"